import React from 'react';
import { Form as AntdForm, FormProps, FormInstance } from 'antd';
import { StyledForm } from './FormStyles';

export interface IFormProps extends FormProps {
  children: React.ReactNode;
}

export type IFormInstance = FormInstance;
export type TFieldsErrors = ReturnType<IFormInstance['getFieldsError']>;

export const { useForm, useWatch: useWatchForm, useFormInstance } = AntdForm;

const Form = ({ children, ...props }: IFormProps): JSX.Element => {
  return (
    <StyledForm layout="vertical" {...props} noValidate>
      {children}
    </StyledForm>
  );
};

export default Form;
